import React from 'react';
import SuperAdminHeader from './SuperAdminHeader';
import SuperAdminSidebar from './SuperAdminSidebar';
import { SidebarProvider } from '../../../context/SidebarContext';

/**
 * SuperAdminLayout Component
 *
 * Layout wrapper for Super Admin pages that matches the Admin layout pattern.
 * Includes header, sidebar, and main content area with consistent styling.
 *
 * @param {Object} props
 * @param {ReactNode} props.children - Content to render in main area
 */
export default function SuperAdminLayout({ children }) {
    return (
        <SidebarProvider defaultOpen={true}>
            <div className="flex flex-col h-screen bg-gray-50 overflow-hidden">
                {/* Shared Header Component */}
                <SuperAdminHeader />

                {/* Main Content Wrapper */}
                <div className="flex flex-1 overflow-hidden">
                    {/* Super Admin Sidebar */}
                    <SuperAdminSidebar />

                    {/* Main Content Area */}
                    <main className="flex-1 overflow-auto bg-gray-50">
                        {children}
                    </main>
                </div>
            </div>
        </SidebarProvider>
    );
}
